export const STATUS_SET = "STATUS_SET";
export const LOGOUT = "LOGOUT";

export const AGENT_SET = "AGENT_SET";
export const AGENT_SET_STATES = "AGENT_SET_STATES";
export const AGENT_SET_CURRENT_STATE = "AGENT_SET_CURRENT_STATE";
export const AGENT_SET_QUEUES = "AGENT_SET_QUEUES";
export const AGENT_SET_ACW_STATE = "AGENT_SET_ACW_STATE";
export const RESET_AGENT_SET_ACW_STATE = "RESET_AGENT_SET_ACW_STATE";
export const AGENT_SET_CANNEDRESPONSES = "AGENT_SET_CANNEDRESPONSES";
export const AGENT_UPDATE_STATE = "AGENT_UPDATE_STATE";
export const AGENT_UPDATE_STATE_FROM_AWS = "AGENT_UPDATE_STATE_FROM_AWS";
export const AGENT_UPDATE_GEO_LOCATION = "AGENT_UPDATE_GEO_LOCATION";
export const AGENT_UPDATE_COUNTRY = "AGENT_UPDATE_COUNTRY";

export const INITIATE_RELOGIN = "INITIATE_RELOGIN";
export const INITIATE_LOGIN = "INITIATE_LOGIN";
export const CALL_SET = "CALL_SET";
export const CALL_RESET = "CALL_RESET";
export const CALL_SET_CONSULT = "CALL_SET_CONSULT";
export const CALL_SET_CONSULT_TYPE = "CALL_SET_CONSULT_TYPE";
export const UPDATE_CALL = "UPDATE_CALL";
export const UPDATE_CALL_TRANSFER_ENDPOINTS = "UPDATE_CALL_TRANSFER_ENDPOINTS";
export const RESET_NORMAL_CALL = "RESET_NORMAL_CALL";
export const STORE_LOGIN = "STORE_LOGIN";
export const RESET_STATE = "RESET_STATE";
export const DIAL_CALL_IN_PROGRESS = "DIAL_CALL_IN_PROGRESS";

// Conference call state (separate slice)
export const CONFERENCE_SET = "CONFERENCE_SET";
export const CONFERENCE_RESET = "CONFERENCE_RESET";
export const CONFERENCE_UPDATE = "CONFERENCE_UPDATE";
export const CONFERENCE_SET_CONSULT = "CONFERENCE_SET_CONSULT";
export const UPDATE_CONFERENCE_TRANSFER_ENDPOINTS = "UPDATE_CONFERENCE_TRANSFER_ENDPOINTS";
export const DIAL_CONFERENCE_IN_PROGRESS = "DIAL_CONFERENCE_IN_PROGRESS";
export const HISTORY_FILTER_CONFERENCE_COUNT = "HISTORY_FILTER_CONFERENCE_COUNT";

export const CALLBACK_RESET = "CALLBACK_RESET";
export const CALLBACK_SET = "CALLBACK_SET";
export const UPDATE_NORMAL_CALLBACK = "UPDATE_NORMAL_CALLBACK";

export const VOICEMAIL_SET = "VOICEMAIL_SET";
export const VOICEMAIL_RESET = "VOICEMAIL_RESET";
export const PLAYBACK_MEDIA_URL_SET = "PLAYBACK_MEDIA_URL_SET";
export const UPDATE_NORMAL_VOICEMAIL = "UPDATE_NORMAL_VOICEMAIL";

export const CHAT_RESET = "CHAT_RESET";
export const CHAT_SET = "CHAT_SET";
export const CHAT_MESSAGE = "CHAT_MESSAGE";
export const LOST_MESSAGE = "LOST_MESSAGE";
export const INDIVIDUAL_CHAT_RESET = "INDIVIDUAL_CHAT_RESET";
export const INITIAL_CHAT_SET = "INITIAL_CHAT_SET";

export const CASE_CONNECTED_TIME = "CASE_CONNECTED_TIME";
export const CASE_SET_SUMMARY_ISSUE = "CASE_SET_SUMMARY_ISSUE";
export const CASE_SET_SUGGEST_ISSUE = "CASE_SET_SUGGEST_ISSUE";
export const ACTIVE_CASE_UPDATE = "ACTIVE_CASE_UPDATE";
export const CASE_RESET = "CASE_RESET";
export const CASE_SET = "CASE_SET";
export const INDIVIDUAL_CASE_RESET = "INDIVIDUAL_CASE_RESET";
export const INITIAL_CASE_SET = "INITIAL_CASE_SET";
export const HISTORY_SET = "HISTORY_SET";
export const HISTORY_RESET = "HISTORY_RESET";
export const NEW_HISTORY_SET = "NEW_HISTORY_SET";
export const ADD_CALL_HISTORY = "ADD_CALL_HISTORY";
export const REMOVE_CALL_HISTORY = "REMOVE_CALL_HISTORY";
export const DELETE_CALL_HISTORY = "DELETE_CALL_HISTORY";
export const CALLBACK_HISTORY = "CALLBACK_HISTORY";
export const ADD_CALLBACK_HISTORY = "ADD_CALLBACK_HISTORY";
export const REMOVE_CALLBACK_HISTORY = "REMOVE_CALLBACK_HISTORY";
export const DELETE_CALLBACK_HISTORY = "DELETE_CALLBACK_HISTORY";
export const ADD_VOICEMAIL_HISTORY = "ADD_VOICEMAIL_HISTORY";
export const DELETE_VOICEMAIL_HISTORY = "DELETE_VOICEMAIL_HISTORY";
export const REMOVE_VOICEMAIL_HISTORY = "REMOVE_VOICEMAIL_HISTORY";
export const CHAT_HISTORY = "CHAT_HISTORY";
export const ADD_CHAT_HISTORY = "ADD_CHAT_HISTORY";
export const REMOVE_CHAT_HISTORY = "REMOVE_CHAT_HISTORY";
export const DELETE_CHAT_HISTORY = "DELETE_CHAT_HISTORY";
export const CASE_HISTORY = "CASE_HISTORY";
export const ADD_CASE_HISTORY = "ADD_CASE_HISTORY";
export const REMOVE_CASE_HISTORY = "REMOVE_CASE_HISTORY";
export const DELETE_CASE_HISTORY = "DELETE_CASE_HISTORY";
export const HISTORY_CASE_SET_SUMMARY_ISSUE = "HISTORY_CASE_SET_SUMMARY_ISSUE";
export const HISTORY_CASE_SET_SUGGEST_ISSUE = "HISTORY_CASE_SET_SUGGEST_ISSUE";
export const REROUTE_CASE_DATA = "REROUTE_CASE_DATA";

export const ADD_SPEED_DIAL = "ADD_SPEED_DIAL";
export const EDIT_SPEED_DIAL = "EDIT_SPEED_DIAL";
export const SPEED_DIAL_HISTORY = "SPEED_DIAL_HISTORY";
export const REMOVE_SPEED_DIAL = "REMOVE_SPEED_DIAL";
export const DELETE_SPEED_DIAL = "DELETE_SPEED_DIAL";

export const CUSTOMER_SET = "CUSTOMER_SET";
export const FEATURE_RESET = "FEATURE_RESET";

export const BUSINESS_ATTRIBUTE_SET = "BUSINESS_ATTRIBUTE_SET";
export const FEATURE_SET = "FEATURE_SET";
export const SET_CASE_DETAILS = "SET_CASE_DETAILS";

export const SESSION_SET = "SESSION_SET";
export const WEBRTC_SET = "WEBRTC_SET";
export const SET_CCP_STATE = "SET_CCP_STATE";
export const HISTORY_FILTER_CALL_COUNT = "HISTORY_FILTER_CALL_COUNT";
export const HISTORY_FILTER_CALLBACK_COUNT = "HISTORY_FILTER_CALLBACK_COUNT";
export const HISTORY_FILTER_VOICEMAIL_COUNT = "HISTORY_FILTER_VOICEMAIL_COUNT";
export const HISTORY_FILTER_CHAT_COUNT = "HISTORY_FILTER_CHAT_COUNT";

export const WEBRTC_ERROR = "WEBRTC_ERROR";
export const RESET_WEBRTC_ERROR = "RESET_WEBRTC_ERROR";
export const SESSION_ERROR = "SESSION_ERROR";
export const RESET_SESSION_ERROR = "RESET_SESSION_ERROR";
export const WEBRTC_RESET = "WEBRTC_RESET";
export const SET_WEBRTC_SESSION = "SET_WEBRTC_SESSION";
export const RESET_UNREAD_MESSAGE_COUNT = "RESET_UNREAD_MESSAGE_COUNT";
export const ACTIVE_CHAT_UPDATE = "ACTIVE_CHAT_UPDATE";
export const SET_TRANSFER_END_POINTS_UPDATE = "SET_TRANSFER_END_POINTS_UPDATE";
export const UPDATE_CHAT_TRANSCRIPT = "UPDATE_CHAT_TRANSCRIPT";
export const SET_CURRENT_TAB = "SET_CURRENT_TAB";
export const SET_VPN_STATUS = "SET_VPN_STATUS";
export const SET_CALL_AGENT_STATUS = "SET_CALL_AGENT_STATUS";
export const SET_CHAT_AGENT_STATUS = "SET_CHAT_AGENT_STATUS";
export const SET_CASE_AGENT_STATUS = "SET_CASE_AGENT_STATUS";
export const UPDATE_MEDIA_DEVICES = "UPDATE_MEDIA_DEVICES";
export const UPDATE_SELECTED_MEDIA_DEVICE = "UPDATE_SELECTED_MEDIA_DEVICE";
export const UPDATE_SPEAKER_DEVICE = "UPDATE_SPEAKER_DEVICE";
export const UPDATE_MICROPHONE_DEVICE = "UPDATE_MICROPHONE_DEVICE";
export const UPDATE_RING_ON_DIFFERENT_DEVICES =
  "UPDATE_RING_ON_DIFFERENT_DEVICES";
export const UPDATE_VOICE_NETWORK_STATE = "UPDATE_VOICE_NETWORK_STATE";
export const UPDATE_ASSINGED_QUEUE = "UPDATE_ASSINGED_QUEUE";
export const SET_SELECTED_ATTACHMENT_UPDATE = "SET_SELECTED_ATTACHMENT_UPDATE";
export const SET_UPLOADING_ATTACHMENT_UPDATE =
  "SET_UPLOADING_ATTACHMENT_UPDATE";
export const UPDATE_COOKIE = "UPDATE_COOKIE";
export const INITIATE_DISCONNECT = "INITIATE_DISCONNECT";
export const INITIAL_DETAILS_SET = "INITIAL_DETAILS_SET";
export const INITIATE_LOGIN_SESSION = "INITIATE_LOGIN_SESSION";
export const INITIATE_LOGOUT = "INITIATE_LOGOUT";
export const INITIATE_NAVIGATOR = "INITIATE_NAVIGATOR";
export const SET_CURRENT_SESSION_TAB = "SET_CURRENT_SESSION_TAB";
export const SET_SESSION_CONNECTED = "SET_SESSION_CONNECTED";
export const SET_SESSION_DISCONNECT = "SET_SESSION_DISCONNECT";
export const SET_SESSION_RECONNECT = "SET_SESSION_RECONNECT";
export const RESET_SESSION = "RESET_SESSION";
export const VOICE_UTILIZATION_AVAILABLE = "VOICE_UTILIZATION_AVAILABLE";
export const WEBRTC_SESSION_WINDOW = "WEBRTC_SESSION_WINDOW";
export const SET_WEBRTC_TOKEN = "SET_WEBRTC_TOKEN";
export const SET_MIC_STATUS = "SET_MIC_STATUS";
export const SET_AGENT_GLOBAL_MUTE = "SET_AGENT_GLOBAL_MUTE";
export const SET_AGENT_SELF_CALL_HELD = "SET_AGENT_SELF_CALL_HELD";
export const SET_CURRENT_CCP_INSTANCE = 'SET_CURRENT_CCP_INSTANCE';
export const UNSEND_CHAT_MESSAGE = "UNSEND_CHAT_MESSAGE";

// Simple Chat constants
export const SIMPLE_CHAT_ADD_MESSAGE = "SIMPLE_CHAT_ADD_MESSAGE";
export const SIMPLE_CHAT_RESET = "SIMPLE_CHAT_RESET";

export const SET_IS_VPN_CHECK_COMPLETED_AFTER_LOGIN = "SET_IS_VPN_CHECK_COMPLETED_AFTER_LOGIN";

// Notification constants
export const NOTIFICATION_ADD = "NOTIFICATION_ADD";
export const NOTIFICATION_REMOVE = "NOTIFICATION_REMOVE";
export const NOTIFICATION_MARK_READ = "NOTIFICATION_MARK_READ";
export const NOTIFICATION_MARK_ALL_READ = "NOTIFICATION_MARK_ALL_READ";
export const NOTIFICATION_CLEAR_ALL = "NOTIFICATION_CLEAR_ALL";
export const NOTIFICATION_SET_MUTE = "NOTIFICATION_SET_MUTE";
export const NOTIFICATION_SET = "NOTIFICATION_SET";
export const NOTIFICATION_RESET = "NOTIFICATION_RESET";